/**
 * WhyVyagramTable — small editorial comparison table.
 *
 * Designed to feel like editorial text, not a SaaS feature matrix. Mobile
 * stacks each row into a card so the comparison still reads cleanly when
 * the viewport collapses.
 */
const ROWS = [
  ["Individual host dependency", "Managed hospitality team"],
  ["Variable interiors", "Design-led portfolio"],
  ["OTA fees and platform back-and-forth", "Direct-booking support"],
  ["Unclear gathering rules", "Pre-approved private gathering options"],
  ["Limited shoot support", "Creator and commercial shoot-friendly stays"],
];

export default function WhyVyagramTable({ className = "" }) {
  return (
    <section
      data-testid="why-vyagram-table"
      className={`vyg-section bg-parchment ${className}`}
    >
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-10">
        <p className="vyg-eyebrow text-center">A more considered way to stay</p>
        <h2 className="mt-3 text-center font-display text-3xl sm:text-4xl lg:text-5xl">
          Built for guests who want <span className="font-script text-gold">ease without the trade-offs.</span>
        </h2>
        <p className="editorial-body mx-auto mt-4 max-w-2xl text-center !text-base text-noir/75">
          Vyagram is built for guests who want the ease of a managed stay without losing
          the warmth, privacy, and character of a thoughtfully designed home.
        </p>

        {/* Desktop / tablet: subtle two-column table */}
        <div className="mt-10 hidden overflow-hidden rounded-2xl border border-forest/15 bg-white shadow-card sm:block">
          <div className="grid grid-cols-2 border-b border-forest/10 bg-mist/50 text-[11px] uppercase tracking-[0.18em] text-amber">
            <div className="px-6 py-4">Typical stay platform</div>
            <div className="px-6 py-4 border-l border-forest/10 text-forest">Vyagram</div>
          </div>
          {ROWS.map(([a, b], i) => (
            <div key={a} className={`grid grid-cols-2 ${i < ROWS.length - 1 ? "border-b border-forest/10" : ""}`}>
              <div className="px-6 py-5 text-sm text-noir/70">{a}</div>
              <div className="px-6 py-5 border-l border-forest/10 text-sm font-medium text-forest">{b}</div>
            </div>
          ))}
        </div>

        {/* Mobile: stacked cards so the comparison reads top-down without
            squeezing the columns. */}
        <div className="mt-8 space-y-3 sm:hidden">
          {ROWS.map(([a, b]) => (
            <div key={a} className="rounded-2xl border border-forest/15 bg-white p-4 shadow-card">
              <p className="text-[10px] uppercase tracking-[0.16em] text-amber">Typical stay</p>
              <p className="mt-1 text-sm text-noir/70">{a}</p>
              <div className="my-3 h-px bg-forest/10" />
              <p className="text-[10px] uppercase tracking-[0.16em] text-forest">Vyagram</p>
              <p className="mt-1 text-sm font-medium text-forest">{b}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
